/* Supra home: <sg-cycle> fades through its slides. Pauses when the tab is hidden, stays still under reduced motion. */
(function () {
  'use strict';
  if (customElements.get('sg-cycle')) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class SgCycle extends HTMLElement {
    connectedCallback() {
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-sg-slide]'));
      this.index = 0;
      if (!this.slides.length) return;
      this.setAttribute('data-ready', '');
      this.show(0);
      if (this.slides.length < 2 || reduce) return;
      this.delay = parseInt(this.getAttribute('data-interval'), 10) || 4600;
      this.onVisibility = function () {
        if (document.hidden) this.stop();
        else this.start();
      }.bind(this);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }

    start() {
      this.stop();
      this.timer = window.setInterval(
        function () {
          this.show(this.index + 1);
        }.bind(this),
        this.delay
      );
    }

    stop() {
      window.clearInterval(this.timer);
    }

    show(i) {
      this.index = (i + this.slides.length) % this.slides.length;
      for (var n = 0; n < this.slides.length; n++) {
        this.slides[n].classList.toggle('is-active', n === this.index);
      }
    }
  }

  customElements.define('sg-cycle', SgCycle);
})();
